import { PricingInfoViewItem } from "./pricing-info-view-item.model";

export class PricingInfoViewItemFactory {
  static create(payload: any): PricingInfoViewItem {
    const pricingInfoViewItem = new PricingInfoViewItem();
    pricingInfoViewItem.setPricingKey(payload.getPricingKey());
    pricingInfoViewItem.setPrice(payload.getPrice());
    pricingInfoViewItem.setMaxPrice(payload.getMaxPrice());
    pricingInfoViewItem.setCreated(payload.getCreated());
    pricingInfoViewItem.setModified(payload.getModified());
    pricingInfoViewItem.setPricingQuotaConfiguration(payload.getPricingQuotaConfiguration());
    return pricingInfoViewItem;
  }
}
